import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="mt-24 hairline-t bg-[#0a0a0a]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="font-display font-bold uppercase text-xl tracking-tight">
            Auto<span className="text-[#ff2a2a]">Mobile</span>
          </div>
          <p className="mt-3 text-sm text-zinc-400 max-w-xs">
            Your ride. Your rules. Your community. Built in Canada. PIPEDA compliant.
          </p>
          <div className="mt-4 inline-flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-emerald-400">
            <ShieldCheck className="w-4 h-4" /> PIPEDA Compliant
          </div>
        </div>

        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-zinc-500 mb-4">Product</div>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/marketplace" className="text-zinc-300 hover:text-[#ff2a2a] transition-colors" data-testid="footer-link-marketplace">Marketplace</Link></li>
            <li><Link to="/watchlist" className="text-zinc-300 hover:text-[#ff2a2a] transition-colors" data-testid="footer-link-watchlist">Saved Listings</Link></li>
            <li><Link to="/rides" className="text-zinc-300 hover:text-[#ff2a2a] transition-colors" data-testid="footer-link-rides">Ride Share</Link></li>
            <li><Link to="/events" className="text-zinc-300 hover:text-[#ff2a2a] transition-colors" data-testid="footer-link-events">Events</Link></li>
            <li><Link to="/maps" className="text-zinc-300 hover:text-[#ff2a2a] transition-colors" data-testid="footer-link-maps">Maps &amp; Amenities</Link></li>
            <li><Link to="/pricing" className="text-zinc-300 hover:text-[#ff2a2a] transition-colors" data-testid="footer-link-pricing">Pricing</Link></li>
            <li><Link to="/billing" className="text-zinc-300 hover:text-[#ff2a2a] transition-colors" data-testid="footer-link-billing">Billing &amp; Invoices</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-zinc-500 mb-4">Get the app</div>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/download" className="text-zinc-300 hover:text-[#ff2a2a] transition-colors" data-testid="footer-link-download">Download hub</Link></li>
            <li><Link to="/sell" className="text-zinc-300 hover:text-[#ff2a2a] transition-colors" data-testid="footer-link-sell">Sell a vehicle</Link></li>
            <li><Link to="/host-event" className="text-zinc-300 hover:text-[#ff2a2a] transition-colors" data-testid="footer-link-host">Host an event</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-zinc-500 mb-4">Company</div>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/terms" className="text-zinc-300 hover:text-[#ff2a2a] transition-colors" data-testid="footer-link-terms">Terms</Link></li>
            <li><a href="mailto:hello@automobile.direct" className="text-zinc-300 hover:text-[#ff2a2a] transition-colors" data-testid="footer-link-contact">Contact</a></li>
          </ul>
        </div>
      </div>

      <div className="hairline-t">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-zinc-500">
          <div>© {new Date().getFullYear()} AutoMobile. All rights reserved. automobile.direct</div>
          <div className="font-mono tracking-widest uppercase">Built for the culture · Deployed on Cloudflare</div>
        </div>
      </div>
    </footer>
  );
}
